module.exports = __webpack_public_path__ + "img/watch-silver-1.35a3fb61.png";